var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.63,
    height: 69.43,
    viewBox: "0 0 69.63 69.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.75,25.42H7.88c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h53.87c3.38,0,6.23-5.06,6.23-11.06s-2.85-11.06-6.23-11.06H7.88c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h53.87c4.42,0,7.88,5.58,7.88,12.71s-3.46,12.71-7.88,12.71Z",
    fill: "red",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88,25.42c-4.42,0-7.88-5.58-7.88-12.71S3.46,0,7.88,0s7.88,5.58,7.88,12.71-3.46,12.71-7.88,12.71ZM7.88,1.65C4.5,1.65,1.65,6.71,1.65,12.71s2.85,11.06,6.23,11.06,6.23-5.07,6.23-11.06S11.26,1.65,7.88,1.65Z",
    fill: "red",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32,39.21H7.88c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h14.44c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,62.98H7.88c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h16.22c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88,62.98c-4.42,0-7.88-5.58-7.88-12.71s3.46-12.71,7.88-12.71,7.88,5.58,7.88,12.71-3.46,12.71-7.88,12.71ZM7.88,39.21c-3.38,0-6.23,5.07-6.23,11.06s2.85,11.06,6.23,11.06,6.23-5.07,6.23-11.06-2.85-11.06-6.23-11.06Z",
    fill: "red",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.81,69.43H28.92c-.46,0-.82-.37-.82-.82v-25.52c0-6.28-5.11-11.39-11.39-11.39H1.27c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h55.33c7.19,0,13.04,5.85,13.04,13.04v25.52c0,.46-.37.82-.82.82ZM29.74,67.78h38.24v-24.7c0-6.28-5.11-11.39-11.39-11.39H23.04c3.99,2.23,6.7,6.5,6.7,11.39v24.7Z",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphics);
export default __webpack_public_path__ + "static/media/graphics.931abb1ad78f54d7d327fb5f779e0081.svg";
export { ForwardRef as ReactComponent };